import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import Home from "../views/Home.vue";
import CustomerList from "../views/customer/CustomerList.vue";
import Detail from "../views/customer/Detail.vue";
import AddList from "../views/customer/Addlist.vue";
import OutScan from "../views/outScan/Index.vue";
import BackScan from "../views/backScan/Index.vue";
import Scan from "../views/outScan/Scan.vue";
import Set from "../views/outScan/Set.vue";
import ScanBack from "../views/backScan/Scan.vue";
import SetBack from "../views/backScan/Set.vue";
import RecordIndex from "../views/outRecord/RecordIndex.vue";
import RecordDetail from "../views/outRecord/RecordDetail.vue";
import RecordIndexBack from "../views/backRecord/RecordIndex.vue";
import RecordDetailBack from "../views/backRecord/RecordDetail.vue";
import WxIndex from "../views/wxUser/Index.vue";
import WxList from "../views/wxUser/List.vue";
import WxOrder from "../views/wxUser/Order.vue";
import ChangePass from "../views/ChangePass.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/customer",
    name: "CustomerList",
    component: CustomerList,
    children: [
      {
        path: "Detail",
        name: "Detail",
        component: Detail,
      },
    ],
  },
  {
    path: "/customer/AddList",
    name: "AddList",
    component: AddList,
  },
  {
    path: "/ChangePass",
    name: "ChangePass",
    component: ChangePass,
  },
  {
    path: "/outScan",
    name: "OutScan",
    component: OutScan,
    children: [
      {
        path: "/Set",
        name: "Set",
        component: Set,
      },
      {
        path: "/Scan",
        name: "Scan",
        component: Scan,
      },
    ],
  },
  {
    path: "/backScan",
    name: "BackScan",
    component: BackScan,
    children: [
      {
        path: "/Set",
        name: "ScanBack",
        component: SetBack,
      },
      {
        path: "/Scan",
        name: "ScanBack",
        component: ScanBack,
      },
    ],
  },
  {
    path: "/outRecord/RecordIndex",
    name: "RecordIndex",
    component: RecordIndex,
  },
  {
    path: "/outRecord/RecordDetail",
    name: "RecordDetail",
    component: RecordDetail,
  },
  {
    path: "/backRecord/RecordIndex",
    name: "RecordIndexBack",
    component: RecordIndexBack,
  },
  {
    path: "/backRecord/RecordDetail",
    name: "RecordDetailBack",
    component: RecordDetailBack,
  },
  {
    path: "/wxUser/Index",
    name: "WxIndex",
    component: WxIndex,
    meta:{
      title: '查询中心'
    }
  },
  {
    path: "/wxUser/List",
    name: "WxList",
    component: WxList,
    meta:{
      title: '查询中心'
    }
  },
  {
    path: "/wxUser/Order",
    name: "WxOrder",
    component: WxOrder,
    meta:{
      title: '查询中心'
    }
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
